<template>
	<Transition
		leaveActiveClass="transition-all duration-500"
		leaveToClass="pointer-events-none scale-0 opacity-0"
	>
		<div
			class="absolute top-0 right-0 bottom-10 left-0 z-8 flex flex-col items-center justify-center bg-black transition-all"
			v-if="show"
		>
			<div
				class="text-label-primary font-squad text-[64px] leading-21 font-black"
			>
				{{ timerComputed }}
			</div>
			<div class="text-label-secondary mt-5 text-xs font-medium uppercase">
				{{ t('ton') }}
			</div>
			<div
				@click="openLink"
				class="text-label-primary mt-1.5 text-base font-medium"
			>
				#{{ tonBlockNumber }}
			</div>
		</div>
	</Transition>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { WebApp } from '@grammyjs/web-app'

const { t } = useI18n({
	messages: {
		en: {
			ton: 'awaiting ton block'
		},
		ru: {
			ton: 'ожидание тон блока'
		}
	}
})

const props = defineProps<{
	show?: boolean
	timer: number
	tonBlockNumber: number
}>()

const timerComputed = computed(() => {
	if (props.timer < 10) {
		return `0${props.timer}`
	}

	return props.timer.toString()
})

const openLink = () => {
	WebApp.openLink(
		`https://tonscan.org/block/-1:8000000000000000:${props.tonBlockNumber}`
	)
}
</script>
